var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuoteBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-569.000000, -206.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-quote-big",
    transform: "translate(569.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,11.725 C13,6.584 16.892,1.206 23,0 L23.984,2.126 C21.769,2.961 19.821,5.868 19.604,7.872 C22.095,8.264 24,10.419 24,13.021 C24,16.203 21.416,18 18.801,18 C15.786,18 13,15.695 13,11.725 Z M0,11.725 C0,6.584 3.892,1.206 10,0 L10.984,2.126 C8.769,2.961 6.821,5.868 6.604,7.872 C9.095,8.264 11,10.419 11,13.021 C11,16.203 8.416,18 5.801,18 C2.786,18 0,15.695 0,11.725 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoteBig);
export default __webpack_public_path__ + "static/media/icon-quote-big.006b5761b292d11780b9df97abdb1a57.svg";
export { ForwardRef as ReactComponent };